module.exports = __webpack_public_path__ + "static/edit-product-description-below-image-c9c33a4ee2a826b62a075080d1f94530.png";